//IMPORT COLORS
import {
  WHITE,
  TEXT_COLOR,
  PRIMARY_BTN_MK,
  SECONDARY_BTN_MK,
  TITLE_COLOR_MK,
  ICON_COLOR_MK,
  FADE_BG_MK,
  LIGHT_BG_MK,
  FOOTER_BG_MK,
} from "../../utils/colors";

//IMPORT FONTS
import {
  TITLE_SIZE,
  SUB_TITLE_SIZE,
  TEXT_SIZE,
  SUB_TEXT_SIZE,
} from "../../utils/fonts";

//IMPORT NUMBERS
import { WHATS_FLORICULTURA_MK_LINK } from "../../utils/phoneNumbers";

import { useEffect } from "react";
import DynamicTitle from "../../components/DynamicTitle";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BannerAbout from "../../components/BannerAbout";
import { LiaDoveSolid } from "react-icons/lia";
import ServicesCards from "../../components/ServicesCards";
import ServicesImg1 from "../../assets/images/mk-completo.jpg";
import ServicesImg2 from "../../assets/images/mk-gavetas.jpg";
import ServicesImg3 from "../../assets/images/mk-sala.jpg";
import ServicesImg4 from "../../assets/images/mk-cremacao.jpg";
import ServicesImg5 from "../../assets/images/mk-columbario.jpg";
import ServicesImg6 from "../../assets/images/mk-flores.jpg";
import ServicesImg7 from "../../assets/images/mk-sala-cer.jpg";
import ServicesImg8 from "../../assets/images/mk-entrada.jpg";
import LogoMemorial from "../../assets/logo/logo-MK.png";
import BannerSection from "../../components/BannerSection";
import JoinUsCall from "../../components/JoinUsCall";
import LocationCall from "../../components/LocationCall";
import FooterBar from "../../components/FooterBar";
import Obituary from "../../components/Obituary";
import VirtualCandleCall from "../../components/VirtualCandleCall";
import FlowersCall from "../../components/FlowersCall";
import VirtualTour from "../../components/VirtualTour";
import VideoSection from "../../components/VideoSection";
import MemorialPostumo from "../../components/MemorialPostumo";
import RecentPosts from "../../components/RecentPostsCall";
import { LuCircleCheckBig } from "react-icons/lu";
import { PiPlant } from "react-icons/pi";
import { TbHearts } from "react-icons/tb";
import { TbMapCheck } from "react-icons/tb";
import { HiOutlineChip } from "react-icons/hi";
import { LuMessageSquareWarning } from "react-icons/lu";
import { FiPhone } from "react-icons/fi";
import { GrLocation } from "react-icons/gr";
import MemorialBG from "../../assets/images/mk-bg.jpg";
import MemorialBGMob from "../../assets/images/mk-bg-mob.jpg";
import MKFlowers from "../../assets/images/mk-flores-2.jpg";
import "./Memorial.css";

export default function Memorial() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const memorialCards = [
    {
      id: 1,
      title: (
        <h3 style={{ color: TITLE_COLOR_MK, fontSize: TEXT_SIZE }}>
          MEMORIAL COMPLETO
          <br />
          FUNERAL E SEPULTAMENTO
        </h3>
      ),
      image: ServicesImg1,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Melhor do Memorial Krause em um só pacote
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Funeral Completo
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Sepultamento
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Espaço individual para guarda de restos mortais
        </p>
      ),
      icon5: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
    },
    {
      id: 2,
      title: (
        <h3 style={{ color: TITLE_COLOR_MK, fontSize: TEXT_SIZE }}>
          SEPULTAMENTO <br />
          EM GAVETAS
        </h3>
      ),
      image: ServicesImg2,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Cemitério vertical
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Sepultamento em gavetas individuais
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Tecnologia avançada
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Tratamento de gases e não agressão ao meio ambiente
        </p>
      ),
    },
    {
      id: 3,
      title: (
        <h3 style={{ color: TITLE_COLOR_MK, fontSize: TEXT_SIZE }}>
          SALAS DE VELÓRIO EXCLUSIVAS
        </h3>
      ),
      image: ServicesImg3,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          6 Salas modernas de velório
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Ambientes climatizados, automatizados e aconchegantes
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Salas privadas para a família
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Especialista em homenagens que honram histórias de vida
        </p>
      ),
    },
    {
      id: 4,
      title: (
        <h3 style={{ color: TITLE_COLOR_MK, fontSize: TEXT_SIZE }}>
          SERVIÇO
          <br /> DE CREMAÇÃO
        </h3>
      ),
      image: ServicesImg4,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Escolha digna para despedida emocionante
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Respeito e tradição
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Benefícios ambientais e de espaço
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Cerminônia especial de entrega das cinzas{" "}
        </p>
      ),
    },
    {
      id: 5,
      title: (
        <h3 style={{ color: TITLE_COLOR_MK, fontSize: TEXT_SIZE }}>
          SALA PARA CERIMÔNIAS
          <br />
          DE CREMAÇÃO
        </h3>
      ),
      image: ServicesImg7,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Sala exclusiva e especial para cerimônias de despedida de cremação
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Cerimonial personalizado
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Cuidado, amparo e zelo
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Despedida digna e memorável
        </p>
      ),
    },
    {
      id: 6,
      title: (
        <h3 style={{ color: TITLE_COLOR_MK, fontSize: TEXT_SIZE }}>
          COLUMBÁRIO E <br />
          COLUMBÁRIO PARQUE
        </h3>
      ),
      image: ServicesImg5,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Ambiente acolhedor para o repouso das cinzas
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Espaço personalizável com itens particulares do ente querido
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Opção Parque, natureza, beleza e paz
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Escolha 100% sustenável
        </p>
      ),
    },
    {
      id: 7,
      title: (
        <h3 style={{ color: TITLE_COLOR_MK, fontSize: TEXT_SIZE }}>
          FLORICULTURA E <br />
          CAFETERIA
        </h3>
      ),
      image: ServicesImg6,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>Cafeteria</p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Espaço self-service
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Serviço completo de floricultura
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Flores e coroas personalizadas
        </p>
      ),
    },
    {
      id: 8,
      title: (
        <h3 style={{ color: TITLE_COLOR_MK, fontSize: TEXT_SIZE }}>
          ESTRUTURA COMPLETA
        </h3>
      ),
      image: ServicesImg8,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Ambiente moderno com 15 mil m² de área
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Estacionamento com 180 vagas e portaria 24 horas
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Velário e sala exclusiva de despedida pet
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_MK }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Suíte exclusiva para acolher as famílias que precisam repousar
        </p>
      ),
    },
  ];

  return (
    <div className="Memorial">
      <DynamicTitle
        pageTitle="Grupo Krause - Memorial Krause"
        pageMeta="Memorial Krause"
        pageContent="O Memorial Krause foi construído com tecnologias de última geração, que não agridem o meio ambiente e é o melhor e mais moderno cemitério da região."
      />
      <BannerSection
        white={WHITE}
        fadeBG={FADE_BG_MK}
        iconTitle={
          <LiaDoveSolid
            style={{ color: WHITE }}
            className="banner-section-icon"
          />
        }
        bannerTitle={"CEMITÉRIO MEMORIAL KRAUSE"}
        bannerTitleSize={TITLE_SIZE}
        bannerSubTitle={"Um lugar para respeitar vidas e preservar histórias."}
        bannerSubTitleSize={SUB_TITLE_SIZE}
        bannerBG={MemorialBG}
        bannerBGmobile={MemorialBGMob}
      />
      <BannerAbout
        companyBrand={LogoMemorial}
        firstText={` O Cemitério Memorial Krause é a mais recente realização do Grupo
              Krause. Construído com tecnologias de última geração, que não
              agridem o meio ambiente, é o melhor e mais moderno cemitério da
              região.`}
        secondText={`  Com o Cemitério Memorial Krause, as famílias de Novo Hamburgo e
              região agora têm um lugar realmente único para se despedirem de
              seus entes queridos, sempre com respeito ao ser humano e a certeza
              de que cada história de vida é especial.`}
        textColor={TEXT_COLOR}
        textSize={TEXT_SIZE}
      />
      <Container className="memorial-items-section">
        <Row>
          <Col className="memorial-item-container">
            <div className="memorial-item-card">
              <div className="memorial-item-img" />
              <div className="memorial-itens">
                <div className="memorial-itens-title">
                  <PiPlant
                    style={{ color: ICON_COLOR_MK }}
                    className="memorial-itens-icon"
                  />
                  <h3
                    style={{ color: TITLE_COLOR_MK, fontSize: SUB_TITLE_SIZE }}
                  >
                    Respeito à natureza
                  </h3>
                </div>
                <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                  Tratamento de gases para não agredir o meio ambiente
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                  Tecnologia utilizada nos mais modernos cemitérios
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                  Projeto baseado no conceito de biossegurança, sem agressão ao
                  meio ambiente
                </p>
              </div>
            </div>
          </Col>
          <Col className="memorial-item-container">
            <div className="memorial-item-card">
              <div className="memorial-item-img-2" />
              <div className="memorial-itens">
                <div className="memorial-itens-title">
                  <TbHearts
                    style={{ color: ICON_COLOR_MK }}
                    className="memorial-itens-icon"
                  />
                  <h3
                    style={{ color: TITLE_COLOR_MK, fontSize: SUB_TITLE_SIZE }}
                  >
                    Tradição junto a comunidade
                  </h3>
                </div>
                <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                  Um projeto com toda a solidez do Grupo Krause
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                  Integridade e confiança de quem tem mais de 100 anos de
                  atuação
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                  Empresa fundada e reconhecida na região do Vale do Sinos
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="memorial-item-container">
            <div className="memorial-item-card">
              <div className="memorial-item-img-3" />
              <div className="memorial-itens">
                <div className="memorial-itens-title">
                  <TbMapCheck
                    style={{ color: ICON_COLOR_MK }}
                    className="memorial-itens-icon"
                  />
                  <h3
                    style={{ color: TITLE_COLOR_MK, fontSize: SUB_TITLE_SIZE }}
                  >
                    Espaço amplo e seguro
                  </h3>
                </div>
                <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                  15 mil m² de área para receber famílias de forma acolhedora
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                  Espaço para 6 mil gavetas de sepultamento e ossários
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                  180 vagas de estacionamento gratuito
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                  Portaria 24h para visitas com segurança
                </p>
              </div>
            </div>
          </Col>
          <Col className="memorial-item-container">
            <div className="memorial-item-card">
              <div className="memorial-item-img-4" />
              <div className="memorial-itens">
                <div className="memorial-itens-title">
                  <HiOutlineChip
                    style={{ color: ICON_COLOR_MK }}
                    className="memorial-itens-icon"
                  />
                  <h3
                    style={{ color: TITLE_COLOR_MK, fontSize: SUB_TITLE_SIZE }}
                  >
                    Tecnologia a favor das memórias
                  </h3>
                </div>
                <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                  Estrutura inovadora para respeitar histórias e preservar
                  lembranças
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                  Sepultamento e cremação humanizados com cerimônias
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                  Salas de velório e para cerimônias de cremação acolhedoras
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                  Cerimônias de despedidas memoráveis
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <ServicesCards
        white={WHITE}
        iconColor={ICON_COLOR_MK}
        titleColor={TITLE_COLOR_MK}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        cards={memorialCards}
        cardSize={484}
        textTop={152}
        textMinHeight={300}
      />
      <Obituary
        white={WHITE}
        iconColor={ICON_COLOR_MK}
        titleColor={TITLE_COLOR_MK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        subTextSize={SUB_TEXT_SIZE}
        secondaryBtnColor={SECONDARY_BTN_MK}
        primaryBtnColor={PRIMARY_BTN_MK}
        funeralDistanciaCall={true}
      />
      <VirtualCandleCall
        white={WHITE}
        iconColor={ICON_COLOR_MK}
        titleColor={TITLE_COLOR_MK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        primaryBtnColor={PRIMARY_BTN_MK}
      />
      <FlowersCall
        white={WHITE}
        iconColor={ICON_COLOR_MK}
        titleColor={TITLE_COLOR_MK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        primaryBtnColor={PRIMARY_BTN_MK}
        whatsAppFloricultura={WHATS_FLORICULTURA_MK_LINK}
        flowerImage={MKFlowers}
      />
      <VideoSection
        iconColor={ICON_COLOR_MK}
        titleColor={TITLE_COLOR_MK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        titleContent="VEJA COMO PODEMOS FAZER A DIFERENÇA PARA A SUA FAMÍLIA"
        subTextContent="Dê play no vídeo abaixo e conheça os diferenciais desse empreendimento único."
        videoLink="https://youtu.be/Hu9_FD2IPo4"
      />
      <VirtualTour
        iconColor={ICON_COLOR_MK}
        titleColor={TITLE_COLOR_MK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTextContent="Pensar em cada detalhe para garantir uma despedida única e memorável é fundamental para respeitar vidas e preservar histórias."
        mapFrame={
          <iframe
            src="https://www.google.com/maps/embed?pb=!4v1759522858471!6m8!1m7!1sCAoSLEFGMVFpcE01eFByUS1zRFdyLXhWcTQ3X1lfU2EwSkNUSWlDYVdvM012c2FG!2m2!1d-29.68730562256333!2d-51.08185698361376!3f89.44608731353037!4f-9.609968503507162!5f0.7820865974627469"
            width="900"
            height="500"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Virtual Tour Memorial Krause"
          />
        }
      />
      <MemorialPostumo
        white={WHITE}
        iconColor={ICON_COLOR_MK}
        titleColor={TITLE_COLOR_MK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        primaryBtnColor={PRIMARY_BTN_MK}
      />
      <Container className="memorial-warning-container">
        <Row>
          <Col className="location-call-first-col">
            <LuMessageSquareWarning
              style={{ color: ICON_COLOR_MK }}
              className="location-call-icon"
            />
            <h2 style={{ color: TITLE_COLOR_MK, fontSize: TITLE_SIZE }}>
              COMUNICADO
            </h2>
          </Col>
        </Row>
      </Container>
      <Container fluid className="memorial-warning-section">
        <div className="memorial-warning-overlay">
          <Container>
            <Row>
              <Col className="memorial-warning-col">
                <h2 style={{ color: WHITE, fontSize: SUB_TITLE_SIZE }}>
                  Comunicado sobre Exumação
                </h2>
                <p style={{ color: WHITE, fontSize: TEXT_SIZE }}>
                  O Cemitério Memorial Krause informa que, conforme previsto no
                  Termo de Concessão Onerosa de Ossário, o uso das gavetas
                  transitórias possui prazo regulamentar de três anos. Após esse
                  período, é realizado o procedimento de exumação e
                  transferência dos restos mortais para o ossário previamente
                  contratado pela família, em conformidade com as normas legais
                  e sanitárias vigentes.
                </p>
                <p style={{ color: WHITE, fontSize: TEXT_SIZE }}>
                  Alertamos os contratantes que estiverem próximos do vencimento
                  do prazo contratual a entrarem em contato com a administração
                  para regularizar a permanência e acompanhar o agendamento do
                  procedimento. Nos casos em que não houver manifestação dentro
                  do prazo informado, será realizado o procedimento de exumação
                  e acondicionamento dos restos mortais no ossário contratado,
                  conforme autorização previamente concedida na Declaração de
                  Locação de Gaveta.
                </p>
                <p style={{ color: WHITE, fontSize: TEXT_SIZE }}>
                  Reforçamos a importância de manter os dados de contato
                  atualizados junto à administração, garantindo o recebimento
                  das comunicações e a realização do processo de forma
                  acompanhada e transparente.
                </p>
                <div>
                  <h4 style={{ color: WHITE, fontSize: TEXT_SIZE }}>
                    <FiPhone className="memorial-warning-icon" />
                    <a
                      style={{ color: WHITE, fontSize: TEXT_SIZE }}
                      href="tel:05130369660"
                      rel="noopener noreferrer"
                      className="memorial-warning-link"
                    >
                      (51) 3036-9660
                    </a>{" "}
                    |{" "}
                    <a
                      style={{ color: WHITE, fontSize: TEXT_SIZE }}
                      href="tel:051992422909"
                      rel="noopener noreferrer"
                      className="memorial-warning-link"
                    >
                      (51) 99242-2909
                    </a>
                  </h4>
                  <h4 style={{ color: WHITE, fontSize: TEXT_SIZE }}>
                    <GrLocation className="memorial-warning-icon" />
                    Cemitério Memorial Krause
                  </h4>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
      <RecentPosts
        white={WHITE}
        iconColor={ICON_COLOR_MK}
        titleColor={TITLE_COLOR_MK}
        textColor={TEXT_COLOR}
        btnColor={ICON_COLOR_MK}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        subTextSize={SUB_TEXT_SIZE}
      />
      <LocationCall
        white={WHITE}
        iconColor={ICON_COLOR_MK}
        titleColor={TITLE_COLOR_MK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        fadeBG={FADE_BG_MK}
      />
      <JoinUsCall
        white={WHITE}
        iconColor={ICON_COLOR_MK}
        titleColor={TITLE_COLOR_MK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        fadeBG={FADE_BG_MK}
        circleBG={LIGHT_BG_MK}
        btnColor={PRIMARY_BTN_MK}
      />
      <FooterBar titleColor={TITLE_COLOR_MK} footerBarBG={FOOTER_BG_MK} />
    </div>
  );
}
